/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Optional_Tech_SkillsInputs */

const en_optional_tech_skills = /** @type {(inputs: Optional_Tech_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optional Tech Skills`)
};

const de_optional_tech_skills = /** @type {(inputs: Optional_Tech_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optionale Tech-Skills`)
};

/**
* | output |
* | --- |
* | "Optional Tech Skills" |
*
* @param {Optional_Tech_SkillsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const optional_tech_skills = /** @type {((inputs?: Optional_Tech_SkillsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Optional_Tech_SkillsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_optional_tech_skills(inputs)
	return en_optional_tech_skills(inputs)
});